// AWS Amplify Face Liveness settings, for the selfie step of the Regula flow.

export default {
    /**
     * → `Amplify.configure({ Auth: { Cognito } })`.
     *
     * The detector streams video to Rekognition from the browser and signs those requests itself, so
     * it needs AWS credentials of its own. Our backend has none to give — it holds long-lived keys
     * that must never leave the server — so the browser gets short-lived guest credentials from a
     * Cognito identity pool instead. Nobody signs in anywhere in this flow, so there is no user pool:
     * `allowGuestAccess` is the whole point of the block.
     */
    auth: {
        identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
        allowGuestAccess: true,
    },

    liveness: {
        // → the detector's `region` prop. Has to match the region our backend mints the session in;
        // the session response does not carry it, so the two are configured independently.
        region: process.env.REACT_APP_AWS_LIVENESS_REGION || 'us-east-1',
        /**
         * Ours, not the vendor's. The component bounds each challenge it runs, but nothing bounds how
         * long a user can sit in front of the start screen — and the session the backend minted is
         * only good for 15 minutes, after which every call against it answers 404. So the wait ends
         * the attempt here first, while it can still be reported as a timeout.
         */
        captureTimeout: 180000,
    },
};
